import {Component, OnInit, Output, EventEmitter, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-control-actions',
  templateUrl: './control-actions.component.html',
  styleUrls: ['./control-actions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ControlActionsComponent implements OnInit {
  @Output() controlActions: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  fieldActions(event) {
    this.controlActions.emit(event);
  }

}
